import { Button } from '@design-system/components/button/button';
import { UploadVideoVM } from '../../view-models/uploadVideo.viewModel';
import { listCta } from './VideoUploadStateModal.css';
import { clsx } from 'clsx';

export const UpladCta = ({
  dispatch,
  showUpload,
  uploadDisabled,
}: {
  dispatch: UploadVideoVM['dispatch'];
  showUpload: boolean;
  uploadDisabled: boolean;
}) => {
  return (
    <div className={clsx(listCta)}>
      <Button variant="text" color="neutral" onClick={() => dispatch('cancel')}>
        Cancel
      </Button>
      {showUpload ? (
        <Button
          disabled={uploadDisabled}
          color="neutral"
          onClick={() => dispatch('upload')}
        >
          Upload
        </Button>
      ) : null}
    </div>
  );
};
